export default class ObservableService<Events extends string> {
  private _mapObservers: Map<string, Function[]> = new Map();

  addObserver(event: Events, callback: Function) {
    const observers = this._mapObservers.get(event);
    if (observers) {
      observers.push(callback);
    } else {
      this._mapObservers.set(event, [callback]);
    }
  }

  removeObserver(event: Events, callback: Function) {
    const observers = this._mapObservers.get(event);
    if (observers) {
      const newObservers = observers.filter(
        (observer) => observer !== callback
      );
      this._mapObservers.set(event, newObservers);
    }
  }

  notifyObservers(event: Events, ...args: any[]) {
    const observers = this._mapObservers.get(event);
    observers && observers.forEach((observer) => observer(...args));
  }
}
